export const ONE_DAY = 24 * 60 * 60 * 1000;
